import React from 'react';
import { NumberInputRow } from '@/components/form/NumberInputRow';

interface PaymentTermsSectionProps {
  paymentTermsInput: {
    inputProps: Record<string, unknown>;
    errorElement?: React.ReactNode;
  };
}

export const PaymentTermsSection: React.FC<PaymentTermsSectionProps> = ({
  paymentTermsInput,
}) => {
  return (
    <NumberInputRow
      id="paymentTermsDays"
      label="Payment Terms (Days)"
      description="Standard time clients have to pay (typically Net-30)"
      unit="days"
      unitPosition="right"
      placeholder="e.g. 30"
      inputProps={paymentTermsInput.inputProps}
      errorElement={paymentTermsInput.errorElement}
    />
  );
};
